import {combineReducers} from 'redux';
import GameReducer from './reducer';

export default combineReducers({
    GameReducer : GameReducer
});